module.exports = __webpack_public_path__ + "img/banner_inv.44d70dd7.jpg";